module.exports = __webpack_public_path__ + "img/5-3.83870af1.svg";